/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  HeroSectionService,
  IHeroSectionMethods,
  MainSectionService,
  IMainSectionMethods,
  FooterService,
  IFooterMethods,
  ImageFeatureSectionService,
  IImageFeatureSectionMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  IHeaderNavContentMethods,
  HeaderNavContentService,
  IHowItWorksMethods,
  HowItWorksService,
} from "./components";

export type ProductLandingPageAgent = IHeaderMethods &
  IHeroSectionMethods &
  IImageFeatureSectionMethods &
  IMainSectionMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IHeaderNavContentMethods &
  IHowItWorksMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new HeroSectionService(),
    new ImageFeatureSectionService(),
    new MainSectionService(),
    new FeatureSectionService(),
    new FooterService(),
    new HeaderNavContentService(),
    new HowItWorksService(),
  ];
};

export const getAgent = () => {
  return createAgent<ProductLandingPageAgent>({
    plugins: getPlugins(),
  });
};
